module.exports = __webpack_public_path__ + "static/media/20180524-LCS-010-11.57acbd6c.jpg";